import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

import { ReachSummary } from '../use-reach-summary';
import { Metric } from './metric';

export function Summary() {
  const { reachSummary, isFetching } = useEditCampaignContext();

  return (
    <div className="bg-fx-neutral-50 flex flex-col gap-6 rounded p-4">
      <Typography variant="subtitle2">
        <FormattedMessage
          defaultMessage="Summary"
          description="Reach editor: headline for target metrics recap"
        />
      </Typography>

      <Typography variant="small1" className="!text-fx-neutral-600">
        <FormattedMessage
          defaultMessage="Reach campaigns are a sum of all channel data"
          description="Explains that metrics combine all selected publishers in Reach"
        />
      </Typography>

      <div className="grid grid-cols-2 gap-4">
        {(Object.keys(reachSummary) as (keyof ReachSummary)[]).map(
          metricKey => (
            <>
              {metricKey !== 'perDayBudget' && (
                <Metric
                  key={metricKey}
                  metricKey={metricKey}
                  value={reachSummary[metricKey]}
                  className={clsx(
                    'col-span-1',
                    metricKey === 'targetHires' && 'col-span-2',
                  )}
                  isFetching={isFetching}
                />
              )}
            </>
          ),
        )}
      </div>
    </div>
  );
}
